module.exports = __webpack_public_path__ + "fonts/ubuntu-v14-latin-700.21d6f2c.ttf";